Object.defineProperty(exports, "__esModule", { value: true });
var PRODUCT_PATH_MAP = {
    'car-insurance': 'car',
    'bike-insurance': 'bike',
    'two-wheeler': 'bike',
    'health-insurance': 'health',
    'travel-insurance': 'travel',
    'term-insurance': 'term',
};
function getAllTollFree() {
    if (window['CONTACT_US']) {
        return window['CONTACT_US'];
    }
    return {
        car: '1800 209 9930',
        bike: '1800 209 9970',
        health: '1800 209 9920',
        travel: '1800 209 9920',
        term: '1800 209 9940',
        other: '1800 209 9970',
        aegon: '1800 209 9090',
    };
}
function getProductName() {
    var URL = window.location.pathname;
    for (var key in PRODUCT_PATH_MAP) {
        if (URL.indexOf(key) !== -1) {
            return PRODUCT_PATH_MAP[key];
        }
    }
    return null;
}
exports.getTollFree = function () {
    var productName = getProductName();
    var tollFrees = getAllTollFree();
    return productName ? tollFrees[productName] : tollFrees['other'];
};
